export default {
  title: 'Comanda nr. {{number}}',
  labels: {
    item: '{{count}} articol',
    item_other: '{{count}} articole',
  },
  buttons: {
    details: 'Detalii',
  },
  fulfillment_statuses: {
    created: 'Creată',
    reviewed: 'Verificată',
    accepted: 'Acceptată',
    preparing: 'În pregătire',
    ready: 'Gata',
    on_delivery: 'În livrare',
    picked: 'Ridicată',
    rejected: 'Respinsă',
  },
};
